/**
 * This utility function returns a formated date
 *
 * Using locale "fr" the output would be : 10 février 2022
 */
function dateFormat(date, locale = "fr") {
  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}

export default dateFormat
